import { loadable } from 'utils';

export const Basic = loadable(() => import('./Basic'), {});
export const TransferMethod = loadable(() => import('./TransferMethod'), {});
